import { render, staticRenderFns } from "./BulkMail.vue?vue&type=template&id=53416e7e&scoped=true"
import script from "./BulkMail.vue?vue&type=script&lang=js"
export * from "./BulkMail.vue?vue&type=script&lang=js"
import style0 from "./BulkMail.vue?vue&type=style&index=0&id=53416e7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53416e7e",
  null
  
)

export default component.exports